"use strict";
initMap();
Object.defineProperty(exports, "__esModule", { value: true });
function initMap() {
  let markerImage = "";
  if (!window.settings) return;
  if (window.settings.marker_image) markerImage = window.settings.marker_image;

  const location = window.settings.location;
  const latLng = {
    lat: parseFloat(location.split(',')[0].replace("(", "")),
    lng: parseFloat(location.split(',')[1].replace(")", ""))
  };

  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 7.5,
    center: latLng,
    navigationControl: false,
    scrollwheel: false,
    streetViewControl: true
  });

  if (markerImage) {
    const marker = new google.maps.Marker({
      position: latLng,
      map,
      icon: markerImage
    });
  } else {
    const marker = new google.maps.Marker({
      position: latLng,
      map
    });
  }
}